import { createSelector } from 'reselect'

const getSystemError = state => state.systemError || {}

export const systemErrorVisible = createSelector([getSystemError], systemError => !!systemError.visible)
export const systemErrorMessage = createSelector([getSystemError], systemError => systemError.message)
